import React, { FC, useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Navigate, Routes, useNavigate, useLocation, useMatch } from "react-router-dom";
import { BackArrow, Button, ModalVariables, Tabs, TopProgress } from "../../components";
import {
  Container,
  InstanceName,
  NavWrapper,
} from './styles'
import {
  MyProfile,
  Personalization,
  Security,
  GoogleAuth,
  ApiAccessPage,
  Notifications
} from './components'
import { authService } from "../../api";
import { useUi } from "../../context/ui.context";
import { useAuth } from "../../context/user.context";
import { tabPermissionSurfaces, usePermissionDecision } from '../../permissions';


const AccountSettings:FC = () => {
  const navigate = useNavigate()
  const [t] = useTranslation()
  const {appMenu, user} = useAuth()
  const {viewAlert} = useUi()
  const [options, setOptions] = useState(false)
  const [activeTab, setActiveTab] = useState<string>('1')
  const location = useLocation()
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>()
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [googleAuth, setGoogleAuth] = useState<boolean>(false)
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const canViewApiAccess = usePermissionDecision(tabPermissionSurfaces.accountSettingsApiAccess).allowed
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }
  const closeModal = (values:any) => {
    if(modalType === 'confirm-password') {
      setLoading(true)
      authService.confirmPasswordSfa(values)
      .then((res:any) => {
        navigate('/account-settings/security')
        setActiveTab('2')
      })
      .catch((e:any) => {
        if(e.response.data.detail){
          viewAlert({
            severity:'error',
            message:e.response.data.detail,
          })
        } 
      })
      .finally(() => {
        setViewModal(false)
        setActiveAnimation(false)
        setLoading(false)
      })
    } else {
      setViewModal(false)
      setActiveAnimation(false)
    }
  }

  useEffect(() => {
  authService.getStatus2fa()
    .then((res) => {
      setGoogleAuth(res.data.tfa_enable)
    })
    .catch((e) => {
      console.log('err get google auth', e?.response?.detail);
      // removeItemFromLs('userToken')
      // window.location.reload()
    })
    .finally(() => {
      setPageLoading(false)
    })
    visibleTabs.map((item:any) => {
      if(location.pathname.includes(item.slug)){
        // if(item.slug === 'security'){

        // } else {
          setActiveTab(item.slug)
        // }
      }
    })
  },[location])
  const tabs = appMenu?.includes("openstack.apiusers") ? [
    {
      title:t("MY_PROFILE"),
      slug:'my-profile',
      id:'1'
    },
    {
      title:t("SECURITY"),
      slug:'security',
      id:'2'
    },
    {
      title:t("PERSONALIZATION"),
      slug:'personalization',
      id:'3'
    },
    {
      title:t("API_ACCESS"),
      slug:'api-access',
      id:'4',
      visible: canViewApiAccess,
    },
    {
      title:t("NOTIFICATIONS", { defaultValue: "Notifications" }),
      slug:'notifications',
      id:'5'
    },
  ]
  :
  [
    {
      title:t("MY_PROFILE"),
      slug:'my-profile',
      id:'1'
    },
    {
      title:t("SECURITY"),
      slug:'security',
      id:'2'
    },
    {
      title:t("PERSONALIZATION"),
      slug:'personalization',
      id:'3'
    },
    {
      title:t("NOTIFICATIONS", { defaultValue: "Notifications" }),
      slug:'notifications',
      id:'4'
    },
  ]
  const visibleTabs = tabs.filter((tab:any) => tab.visible !== false)
  const defaultTab = visibleTabs[0]?.slug || 'my-profile'
  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <Container>
      <InstanceName>
        {t("ACCOUNT_SETTINGS")}
      </InstanceName>
      <NavWrapper>
        <div>
          <Tabs
            tabs={visibleTabs}
            size='display'
            blockNavigate
            location={activeTab}
            onChange={(e) => {
              if(e === 'security'){
                // openModal('confirm-password')
                navigate(`/account-settings/${e}`)
              } else {
                navigate(`/account-settings/${e}`)
              }
            }}
          />
        </div>
      </NavWrapper>
      <Routes>
        <Route index element={<Navigate replace to={defaultTab} />} /> 
        <Route path='my-profile' element={<MyProfile/>}/>
        <Route path='personalization' element={<Personalization/>}/>
        <Route path='security' element={<Security/>}/>
        {canViewApiAccess &&
          <Route path='api-access' element={<ApiAccessPage/>}/>
        }
        <Route path='notifications' element={<Notifications />}/>
        <Route path='*' element={<Navigate replace to={defaultTab} />} />
      </Routes>
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={loading}
        instance={{google:googleAuth}}
      />
    </Container>
  )
}

export default AccountSettings
